import MyService from '../../service';

const DistrictApi = {
  getAll: async () => {
    try {
      const { data } = await MyService.getRequestData('/partners/districts');

      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },
  getDistrictByCityId: async (cityId) => {
    try {
      const {
        data,
      } = await MyService.getRequestData(
        '/partners/districts/getDistrictByCityId',
        { city_id: cityId }
      );

      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },
};

export default DistrictApi;
